import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_17181562 from 'nuxt_plugin_plugin_17181562' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0409066c from 'nuxt_plugin_plugin_0409066c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_7403d5e7 from 'nuxt_plugin_recaptcha_7403d5e7' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_image_2bbcc073 from 'nuxt_plugin_image_2bbcc073' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vuescrollto_59c8eb91 from 'nuxt_plugin_vuescrollto_59c8eb91' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_412d19c0 from 'nuxt_plugin_cookieuniversalnuxt_412d19c0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_175109c3 from 'nuxt_plugin_pluginutils_175109c3' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3d36324e from 'nuxt_plugin_pluginrouting_3d36324e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_39228be1 from 'nuxt_plugin_pluginmain_39228be1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginserver_f72cece0 from 'nuxt_plugin_pluginserver_f72cece0' // Source: ./plugin.server.js (mode: 'server')
import nuxt_plugin_distplugin57527824_268e2af4 from 'nuxt_plugin_distplugin57527824_268e2af4' // Source: ./dist.plugin.57527824.mjs (mode: 'all')
import nuxt_plugin_nuxtpluginc6125a82_c9c34d54 from 'nuxt_plugin_nuxtpluginc6125a82_c9c34d54' // Source: ./nuxt.plugin.c6125a82.js (mode: 'all')
import nuxt_plugin_nuxtplugin6726cb40_19d7b890 from 'nuxt_plugin_nuxtplugin6726cb40_19d7b890' // Source: ./nuxt.plugin.6726cb40.js (mode: 'all')
import nuxt_plugin_nuxtplugin59bbe3dd_31632b5e from 'nuxt_plugin_nuxtplugin59bbe3dd_31632b5e' // Source: ./nuxt.plugin.59bbe3dd.js (mode: 'all')
import nuxt_plugin_nuxtpluginf0489b9c_bccb6f22 from 'nuxt_plugin_nuxtpluginf0489b9c_bccb6f22' // Source: ./nuxt.plugin.f0489b9c.js (mode: 'all')
import nuxt_plugin_nuxtplugin2838ee5d_e4b43ad4 from 'nuxt_plugin_nuxtplugin2838ee5d_e4b43ad4' // Source: ./nuxt.plugin.2838ee5d.js (mode: 'all')
import nuxt_plugin_nuxtplugin5a7cc15b_6d71febd from 'nuxt_plugin_nuxtplugin5a7cc15b_6d71febd' // Source: ./nuxt.plugin.5a7cc15b.js (mode: 'all')
import nuxt_plugin_refreshtokeninterceptorindex43b25bb4_82cf9206 from 'nuxt_plugin_refreshtokeninterceptorindex43b25bb4_82cf9206' // Source: ./refresh-token-interceptor.index.43b25bb4.ts (mode: 'all')
import nuxt_plugin_pluginsi18ncookies4745f248_16c7e94c from 'nuxt_plugin_pluginsi18ncookies4745f248_16c7e94c' // Source: ./plugins.i18n-cookies.4745f248.js (mode: 'all')
import nuxt_plugin_pluginse2etesting38f658eb_83494cac from 'nuxt_plugin_pluginse2etesting38f658eb_83494cac' // Source: ./plugins.e2e-testing.38f658eb.js (mode: 'all')
import nuxt_plugin_pluginslogger6bab7958_94894468 from 'nuxt_plugin_pluginslogger6bab7958_94894468' // Source: ./plugins.logger.6bab7958.js (mode: 'all')
import nuxt_plugin_pluginsssr2cb5d954_4cd4963e from 'nuxt_plugin_pluginsssr2cb5d954_4cd4963e' // Source: ./plugins.ssr.2cb5d954.js (mode: 'all')
import nuxt_plugin_pluginscontext0b091dd2_1aabb037 from 'nuxt_plugin_pluginscontext0b091dd2_1aabb037' // Source: ./plugins.context.0b091dd2.js (mode: 'all')
import nuxt_plugin_workbox_6c233a94 from 'nuxt_plugin_workbox_6c233a94' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_d99aa4b2 from 'nuxt_plugin_metaplugin_d99aa4b2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_d04b59ca from 'nuxt_plugin_iconplugin_d04b59ca' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_70ee6303 from 'nuxt_plugin_deviceplugin_70ee6303' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_addcurrencytorequest_3fc87180 from 'nuxt_plugin_addcurrencytorequest_3fc87180' // Source: ../plugins/add-currency-to-request.js (mode: 'all')
import nuxt_plugin_injectstoreconfiguration_21ad4e9a from 'nuxt_plugin_injectstoreconfiguration_21ad4e9a' // Source: ../plugins/inject-store-configuration.js (mode: 'all')
import nuxt_plugin_imagehelpers_b58834a0 from 'nuxt_plugin_imagehelpers_b58834a0' // Source: ../plugins/image-helpers.ts (mode: 'all')
import nuxt_plugin_bloomreachvuesdk_a5c37eea from 'nuxt_plugin_bloomreachvuesdk_a5c37eea' // Source: ../plugins/bloomreach-vue-sdk.js (mode: 'all')
import nuxt_plugin_sanitizehtml_0862df04 from 'nuxt_plugin_sanitizehtml_0862df04' // Source: ../plugins/sanitize-html.js (mode: 'all')
import nuxt_plugin_persistedstate_38254ec5 from 'nuxt_plugin_persistedstate_38254ec5' // Source: ../plugins/persistedstate.js (mode: 'all')
import nuxt_plugin_notifications_36de4932 from 'nuxt_plugin_notifications_36de4932' // Source: ../plugins/notifications (mode: 'client')
import nuxt_plugin_meta_1d50025c from 'nuxt_plugin_meta_1d50025c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Moomin by Arabia | Embark on an Adventure in Moominvalley","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"## Build Setup Steps"},{"hid":"google-site-verification","name":"google-site-verification","content":"JXxw88AbF0jsAeq201zCA6I0uXlblm8cADzg47C0Up4"},{"name":"generator","content":"Vue Storefront 2"}],"script":[{"src":"\u002Fscripts\u002FoptanonWrapper.js","type":"text\u002Fjavascript"},{"src":"\u002Fscripts\u002Fprod\u002Fmetarouter.js","type":"text\u002Fjavascript"},{"src":"\u002Fscripts\u002Fgoogletagmanager.js","type":"text\u002Fjavascript","async":true},{"src":"\u002Fscripts\u002Fprod\u002FoneTrust.js","type":"text\u002Fjavascript"},{"src":"\u002Fscripts\u002Fprod\u002Fbloomreach-engagement.js","type":"text\u002Fjavascript"}],"link":[{"rel":"icon","type":"image\u002Fsvg","href":"\u002Ffavicon.svg"},{"rel":"stylesheet","href":"\u002Ffonts\u002FMyFontsWebfontsKit\u002FMyFontsWebfontsKit.css","async":true}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_17181562 === 'function') {
    await nuxt_plugin_plugin_17181562(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0409066c === 'function') {
    await nuxt_plugin_plugin_0409066c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_7403d5e7 === 'function') {
    await nuxt_plugin_recaptcha_7403d5e7(app.context, inject)
  }

  if (typeof nuxt_plugin_image_2bbcc073 === 'function') {
    await nuxt_plugin_image_2bbcc073(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_59c8eb91 === 'function') {
    await nuxt_plugin_vuescrollto_59c8eb91(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_412d19c0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_412d19c0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_175109c3 === 'function') {
    await nuxt_plugin_pluginutils_175109c3(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3d36324e === 'function') {
    await nuxt_plugin_pluginrouting_3d36324e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_39228be1 === 'function') {
    await nuxt_plugin_pluginmain_39228be1(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_f72cece0 === 'function') {
    await nuxt_plugin_pluginserver_f72cece0(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin57527824_268e2af4 === 'function') {
    await nuxt_plugin_distplugin57527824_268e2af4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginc6125a82_c9c34d54 === 'function') {
    await nuxt_plugin_nuxtpluginc6125a82_c9c34d54(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin6726cb40_19d7b890 === 'function') {
    await nuxt_plugin_nuxtplugin6726cb40_19d7b890(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin59bbe3dd_31632b5e === 'function') {
    await nuxt_plugin_nuxtplugin59bbe3dd_31632b5e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtpluginf0489b9c_bccb6f22 === 'function') {
    await nuxt_plugin_nuxtpluginf0489b9c_bccb6f22(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin2838ee5d_e4b43ad4 === 'function') {
    await nuxt_plugin_nuxtplugin2838ee5d_e4b43ad4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin5a7cc15b_6d71febd === 'function') {
    await nuxt_plugin_nuxtplugin5a7cc15b_6d71febd(app.context, inject)
  }

  if (typeof nuxt_plugin_refreshtokeninterceptorindex43b25bb4_82cf9206 === 'function') {
    await nuxt_plugin_refreshtokeninterceptorindex43b25bb4_82cf9206(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18ncookies4745f248_16c7e94c === 'function') {
    await nuxt_plugin_pluginsi18ncookies4745f248_16c7e94c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting38f658eb_83494cac === 'function') {
    await nuxt_plugin_pluginse2etesting38f658eb_83494cac(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginslogger6bab7958_94894468 === 'function') {
    await nuxt_plugin_pluginslogger6bab7958_94894468(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssr2cb5d954_4cd4963e === 'function') {
    await nuxt_plugin_pluginsssr2cb5d954_4cd4963e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscontext0b091dd2_1aabb037 === 'function') {
    await nuxt_plugin_pluginscontext0b091dd2_1aabb037(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6c233a94 === 'function') {
    await nuxt_plugin_workbox_6c233a94(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_d99aa4b2 === 'function') {
    await nuxt_plugin_metaplugin_d99aa4b2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_d04b59ca === 'function') {
    await nuxt_plugin_iconplugin_d04b59ca(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_70ee6303 === 'function') {
    await nuxt_plugin_deviceplugin_70ee6303(app.context, inject)
  }

  if (typeof nuxt_plugin_addcurrencytorequest_3fc87180 === 'function') {
    await nuxt_plugin_addcurrencytorequest_3fc87180(app.context, inject)
  }

  if (typeof nuxt_plugin_injectstoreconfiguration_21ad4e9a === 'function') {
    await nuxt_plugin_injectstoreconfiguration_21ad4e9a(app.context, inject)
  }

  if (typeof nuxt_plugin_imagehelpers_b58834a0 === 'function') {
    await nuxt_plugin_imagehelpers_b58834a0(app.context, inject)
  }

  if (typeof nuxt_plugin_bloomreachvuesdk_a5c37eea === 'function') {
    await nuxt_plugin_bloomreachvuesdk_a5c37eea(app.context, inject)
  }

  if (typeof nuxt_plugin_sanitizehtml_0862df04 === 'function') {
    await nuxt_plugin_sanitizehtml_0862df04(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedstate_38254ec5 === 'function') {
    await nuxt_plugin_persistedstate_38254ec5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_notifications_36de4932 === 'function') {
    await nuxt_plugin_notifications_36de4932(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1d50025c === 'function') {
    await nuxt_plugin_meta_1d50025c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
